<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-academies">

        <page-title :title="'Akademie'" :back="true" :routeName="'Knowledge'"></page-title>

        <div v-for="(item,index) in academies" :key="item.slug">
            <item-academy
                    style="margin: 5px 0 20px 0px;"
                    :index="index+1"
                    :slug="item.slug"
                    :name="item.name"
                    :title="item.title"
                    :image="item.image">
            </item-academy>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import PageTitle from '@/components/PageTitle.vue';
    import ItemAcademy from '@/items/ItemAcademy';

    export default {
        name: 'Academies',
        components: { PageTitle, ItemAcademy },
        computed: {
            ...mapState({
                loading: state => state.academies.loading,
                academies: state => state.academies.data
            })
        },
        mounted(){
            this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_REQUEST')
        }
    }
</script>
